<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import store from "../../store";
    import {bus} from "../../vue_bus";

    export default {
        name: "WorkspaceFabricPreAdditionalElementsTool",
        mixins: [urlForFileStorage],
        async mounted() {
            await this.initFabric();

            bus.$on("dblclickPlaneFromPlaneVisualisator", (planeID) => {
                let name = this.$store.getters["active/PLANE_BY_ID"](planeID).type;
                if (this.$store.getters["active/PLANE_BY_ID"](planeID).type === "additional")
                    name = "additionalManual";
                else return;

                this.$router.push({
                    name: name,
                    params: {planeID: planeID},
                    query: this.$route.query
                }).catch(() => {

                });
            });
            bus.$on("dblclickPlaneFromPlaneVisualisator", (planeID) => {
                if (this.$route.name === "additional") {
                    this.$router.push({
                        name: "platband",
                        params: {planeID: planeID},
                        query: this.$route.query
                    }).catch(() => {

                    });
                }
            });

            bus.$on('refreshFabric', () => {
                this.editor.destroy();
                this.initFabric();
            })
        },
        destroyed() {
            if (this.editor)
                this.editor.destroy();
            bus.$off("selectedPlaneFromPlaneVisualisator");
            bus.$off("dblclickPlaneFromPlaneVisualisator");
            bus.$off('refreshFabric');
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {
            async initFabric() {
                this.editor = new fabricEditor(this.$refs["fabricJS"]);
                this.editor.updateCanvaSize({
                        width: this.$refs["fabricJSContainer"].offsetWidth,
                        height: this.$refs["fabricJSContainer"].offsetHeight
                    }
                )
                let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
                // this.editor.showPlanesForTools(this.$store.state.route.params.planeID);
                await this.editor.showPlanes();
                // this.editor.addAdditionalElementsTool();
                this.editor.setViewport(source, 1);
                bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
                    if (planeID !== this.$route.params.planeID) {
                        this.$router.replace({
                            name: "additional",
                            params: {planeID: planeID},
                            query: this.$route.query
                        }).catch(() => {
                        });
                    }
                });
            }

        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
